import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import ExtendedInlineEditingGridViewModel from '@/Components/ExtendedInlineEditingGrid/ExtendedInlineEditingGridViewModel';
import ExtendedInlineEditingGrid from '@/Components/ExtendedInlineEditingGrid/ExtendedInlineEditingGrid';
import Utilities from '@/Utility/Utilities';
import { IInlineValidationMessages, IInlineValidationMessage } from '@/Components/ExtendedInlineEditingGrid/IInlineValidationMessage';
import {
    DisposeBehavior,
    IExtendedInlineEditingGridFactoryConstructorParameter,
    IGridControlFactory
} from "#/DefaultViewExtensionInterfaces";

export default class ExtendedInlineEditingGridFactory extends ControlFactory implements IGridControlFactory {

    public controlDomElement: JQuery;

    /**
     * @override 
     */
    public viewModel: ExtendedInlineEditingGridViewModel;

    private ExtendedInlineEditingGridViewModel = ComponentManager.getViewModel<typeof ExtendedInlineEditingGridViewModel>('ExtendedInlineEditingGridViewModel');
    private InlineEditingGrid = ComponentManager.getControl<typeof ExtendedInlineEditingGrid>('ExtendedInlineEditingGrid');

    constructor(private params: IExtendedInlineEditingGridFactoryConstructorParameter) {
        super(params);

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.defineSubscription(this.invalidationText, (text) => this.viewModel.onError(this.convertToMessages(text)));
    }

    public convertToMessages(json: string): IInlineValidationMessages[] {
        if (Utilities.isNullOrUndefinedOrBlank(json))
            return [];

        const result = [];

        const idToMessages = JSON.parse(json);
        const ids = _.keys(idToMessages);

        ids.forEach(id => {
            const messages = idToMessages[id];
            const validationMessages: IInlineValidationMessage[] = _.keys(messages).map(x => {
                return {
                    property: x,
                    message: messages[x]
            }});
            result.push({ pdoId: id, messages: validationMessages });
        });

        return result;
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.controlDomElement != null) {
            return this.controlDomElement;
        }

        this.viewModel = new this.ExtendedInlineEditingGridViewModel({
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            detailViewItem: this.detailViewItem,
            detailViewContext: this.context,
            isSummaryViewMode: this.isSummaryViewMode,
            isEnabled: this.isEnabled,
            isDisplayed: this.isDisplayed,
            excludedMembers: this.params.excludedMembers?.split(','),
            visibleMembers: this.params.visibleMembers?.split(','),
            hiddenMembers: this.params.hiddenMembers?.split(','),
            additionalMembers: this.params.additionalMembers?.split(','),
            primarySubAssociation: this.params.primarySubAssociation,
            editSubAssociation: this.params.editSubAssociation,
            uniqueSubAssociation: this.params.uniqueSubAssociation,
            height: this.params.height,
            navigateOnCreate: this.params.navigateOnCreate,
            isMultiSelection: this.params.isMultiSelection,
            selfValidation: this.params.selfValidation,
        });

        this.control = new this.InlineEditingGrid(this.viewModel, $('<div>'));

        let tuple = this.control.getTuple();
        this.controlDomElement = tuple.control;

        return this.controlDomElement;
    }

    public getContainerPostfix(): KnockoutObservable<string> {
        return this.defineComputed(() => {
            if (this.viewModel.isDisposed)
                return '';

            return this.viewModel.fullExtent();
        });
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }
}

ComponentManager.setFactory('ExtendedInlineEditingGrid', ExtendedInlineEditingGridFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');